<app-header></app-header>

<ion-content>
  <app-api-not-found status="404"> </app-api-not-found>
</ion-content>
